/**
 * ComponentTest - Test page for Simulacra base components
 * TEMPORARY: For verifying Tamagui setup works correctly
 */
import { useState } from 'react';
import { YStack, XStack, H2, ScrollView, Theme, Button } from 'tamagui';
import {
  MatrixButton,
  GlassCard,
  TickerSymbol,
  MessageBubble,
} from '../components/base';

export function ComponentTest() {
  const [theme, setTheme] = useState<'light' | 'dark'>('dark');

  return (
    <Theme name={theme}>
      <ScrollView padding="$4" backgroundColor="$background">
        <YStack gap="$6" width="100%" maxWidth={800} marginHorizontal="auto" paddingHorizontal="$3">
          {/* Header with theme toggle */}
          <XStack justifyContent="space-between" alignItems="center" flexWrap="wrap" gap="$3">
            <H2 color="$green10" fontFamily="$heading" fontSize="$5">
              Simulacra Component Test
            </H2>
            <Button
              size="$3"
              onPress={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
              theme="green"
            >
              {theme === 'dark' ? '☀️ Light' : '🌙 Dark'}
            </Button>
          </XStack>

        {/* Buttons */}
        <GlassCard>
          <H2 fontSize="$4" marginBottom="$3" color="$color">
            MatrixButton Variants
          </H2>
          <XStack gap="$3" flexWrap="wrap" $sm={{ gap: '$2' }}>
            <MatrixButton variant="primary" $sm={{ flex: 1, minWidth: 120 }}>Primary</MatrixButton>
            <MatrixButton variant="secondary" $sm={{ flex: 1, minWidth: 120 }}>Secondary</MatrixButton>
            <MatrixButton variant="danger" $sm={{ flex: 1, minWidth: 120 }}>Danger</MatrixButton>
            <MatrixButton variant="ghost" $sm={{ flex: 1, minWidth: 120 }}>Ghost</MatrixButton>
          </XStack>
        </GlassCard>

        {/* Cards */}
        <GlassCard>
          <H2 fontSize="$4" marginBottom="$3" color="$color">
            GlassCard Variants
          </H2>
          <YStack gap="$3">
            <GlassCard glowOnHover>
              Glass card with glow on hover
            </GlassCard>
            <GlassCard terminal>
              Terminal-style card
            </GlassCard>
          </YStack>
        </GlassCard>

        {/* Ticker Symbols */}
        <GlassCard>
          <H2 fontSize="$4" marginBottom="$3" color="$color">
            TickerSymbol Variants
          </H2>
          <YStack gap="$3">
            <TickerSymbol
              variant="hero"
              symbol="AAPL"
              companyName="Apple Inc."
              exchange="NASDAQ"
              change="+2.5%"
            />
            <TickerSymbol
              variant="card"
              symbol="GOOGL"
              companyName="Alphabet Inc."
              exchange="NASDAQ"
              change="-0.8%"
            />
            <TickerSymbol
              variant="inline"
              symbol="TSLA"
              change="+3.2%"
            />
          </YStack>
        </GlassCard>

        {/* Message Bubbles */}
        <GlassCard>
          <H2 fontSize="$4" marginBottom="$3" color="$color">
            MessageBubble Variants
          </H2>
          <YStack gap="$3">
            <MessageBubble
              role="user"
              content="What were Apple's latest earnings?"
              timestamp="12:34:56"
            />
            <MessageBubble
              role="assistant"
              content="Apple reported record revenue of $123.9B in Q4 2024, exceeding analyst expectations. iPhone sales remained strong with a 12% YoY increase."
              timestamp="12:35:02"
            />
          </YStack>
        </GlassCard>
      </YStack>
    </ScrollView>
    </Theme>
  );
}
